<template>
    <modal :show="show" showLarge>
        <div slot="modalHeader">
          <modal-header :closeModal="close">Edit</modal-header>
        </div>
        <div v-if="creative">
          <form-group>
            <field name="Name" :value="creative.name" v-model="creative.name" :error="errors.name"/>
          </form-group>
          <form-group>
            <field name="Creative Job Number" :value="creative.creative_job_number" v-model="creative.creative_job_number"/>
          </form-group>
          <creative-table :tableData="creative.fields" v-model="creative.fields" @onToggleParentCheckboxes="updateCheckboxData" />
        </div>
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'
import CreativeTable from '@/components/CreativeTable/creative-table'
import {modalMixin} from '@/mixins/modalMixin'
import {campaignMixin} from '@/mixins/campaignMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

import { find, propEq, omit, map, assoc } from 'ramda'

export default {
  name: 'modal_edit_creative',
  mixins: [modalMixin, campaignMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Field,
    CreativeTable
  },
  props: {
    show: Boolean,
    confirmId: String,
    field: String
  },
  data: () => ({
    errors: {
      name: ''
    }
  }),
  created () {},
  computed: {
    creative () {
      if (this.creatives) {
        const creative = find(propEq('hash_id', this.confirmId), this.creatives)
        if (creative) {
          creative.fields = map(item => assoc('editableActions', true, item), creative.fields)
        }
        return creative
      }
    }
  },
  methods: {
    confirm () {
      this.startLoading()
      const updateCreative = omit(['campaign', 'date_created', 'date_updated', 'type', 'units'], this.creative)
      this.updateCreative(updateCreative).then(() => {
        console.log('updateCreative', updateCreative)
        this.getCreatives(this.$route.params.id).then(() => {
          this.addNotification('success', `'${this.field}'s Creative' Successfully updated.`)
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-edit-creative.vue